import {h, Fragment} from "preact"
export default function BottomBanner() {

    return (
        <div class="ns-serp-banner slider_clickable">
            <link href="//mac-center.com/cdn/shop/t/214/assets/section-image-banner.css?v=157856879886144226731725983412" rel="stylesheet" type="text/css" media="all" />
            <link href="//mac-center.com/cdn/shop/t/214/assets/component-slider.css?v=102975581670085299341725983412" rel="stylesheet" type="text/css" media="all" />
            <link href="//mac-center.com/cdn/shop/t/214/assets/component-slideshow.css?v=163632880325516619581725983412" rel="stylesheet" type="text/css" media="all" />
            <div class="search-banner banner-desktop slider-mobile-gutter">
                <div 
                    class="slideshow banner banner--adapt_image grid grid--1-col slider slider--everywhere" 
                >
                <div class="slideshow__slide grid__item grid--1-col slider__slide">
                    <div style="background-color: #fafafa">
                        <div style="background-color: #fafafa" class="slideshow__media banner__media media">
                            <a class="full-link" href="/pages/beneficios" aria-label="Slide"></a>
                            <img 
                                srcset="//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_375x.jpg?v=1712341454 375w,//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_550x.jpg?v=1712341454 550w,//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_750x.jpg?v=1712341454 750w,//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_1100x.jpg?v=1712341454 1100w,//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_1500x.jpg?v=1712341454 1500w,//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_1780x.jpg?v=1712341454 1780w,//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_2000x.jpg?v=1712341454 2000w,//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5.jpg?v=1712341454 2100w" sizes="100vw" src="//mac-center.com/cdn/shop/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5_1500x.jpg?v=1712341454" 
                                alt="" 
                                width="2100" 
                                height="700" 
                            />
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="search-banner banner-mobile slider-mobile-gutter">
                <div class="slideshow banner banner--adapt_image grid grid--1-col slider slider--everywhere">
                <div 
                    class="slideshow__slide grid__item grid--1-col slider__slide" 
                    id="ns-slider-template"
                >
                    <div class="slideshow__media banner__media media">
                        <a class="full-link" href="/pages/beneficios" aria-label="Slide"></a>
                        <img 
                            srcset="//mac-center.com/cdn/shop/files/MOBILE_47cf2b40-7dde-4c87-9627-e93f14c1dded_375x.jpg?v=1712341454 375w,//mac-center.com/cdn/shop/files/MOBILE_47cf2b40-7dde-4c87-9627-e93f14c1dded_550x.jpg?v=1712341454 550w,//mac-center.com/cdn/shop/files/MOBILE_47cf2b40-7dde-4c87-9627-e93f14c1dded.jpg?v=1712341454 600w" sizes="100vw" src="//mac-center.com/cdn/shop/files/MOBILE_47cf2b40-7dde-4c87-9627-e93f14c1dded_1500x.jpg?v=1712341454"
                            alt="" width="600" height="500" 
                        />
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}